/**
 * @author: lv.chen
 * @date: 2025/12/15
 * @desc: ProductChangedCard卡片组件
 */
import React from 'react';
import classnames from 'classnames';
import EllipsisHover from '@home/components/EllipsisHover';
import Bubble from '@home/components/TeaComponents/Bubble';
import GameImage from '@home/components/GameImage';
import { getCountryFlag } from '@home/_config/countries';
import { getSanitizeHTMLString } from '@intelligence/v3/utils/common';
import { CasualDailyReportData, getCardColor } from '@intelligence/v3/pages/CasualDailyReports/utils';

import IMG_ICON_GO from '@intelligence/assets/imgs/casualDailyReports/icon-go.png';

interface IProductChangedCardProps extends IBaseProps {
  markdownConverter: React.MutableRefObject<CasualDailyReportData>;
  renderLinker: any;
  productChanged?: IProductChangeCategory[] | null;
  onGoToGameDetails?: (game?: any) => void;
}

const ProductChangedCard: React.FC<IProductChangedCardProps> = (props) => {
  const { style, className, markdownConverter, renderLinker, productChanged, onGoToGameDetails } = props;

  return (
    <div style={style} className={classnames('dbi-casual-daily-reports-product-changed-card', className)}>
      {productChanged?.map((changeItem, index) => {
        const changeItemTitle = changeItem?.title || '';

        return (
          <div key={index} className="dbi-section-production-content">
            <div className="dbi-section-production-subtitle">
              <div
                className={classnames(
                  'dbi-section-production-subtitle-text',
                  `dbi-section-production-subtitle-color-${getCardColor(changeItemTitle)}`,
                )}
              >
                {changeItemTitle}
              </div>
            </div>
            <div className="dbi-product-update-card">
              <div className="dbi-product-update-card-content">
                {changeItem?.items?.map((item, index) => {
                  const itemEntityName = item?.entity_name || '';
                  const itemCover = item?.cover || '';
                  const itemSuperGenre = item?.super_genre || '';
                  const itemMajorCategory = item?.major_category || '';
                  const showGenres = !!itemSuperGenre || !!itemMajorCategory;
                  const itemIsSpecial = item?.is_special || false;

                  return (
                    <div
                      key={index}
                      className={classnames('dbi-product-update-item', {
                        'no-entity-info': !itemEntityName,
                      })}
                    >
                      {itemIsSpecial && <i className="dbi-icon-featured"></i>}
                      {itemEntityName && (
                        <div className="dbi-item-header">
                          {/* {itemCover && <img className="dbi-game-icon" src={itemCover} alt="icon" />}*/}
                          {itemCover && (
                            <GameImage className="dbi-game-icon" entityType={changeItem?.entity_type} src={itemCover} />
                          )}
                          <div className="dbi-header-info">
                            <div className="dbi-title-row">
                              <div className="dbi-title-container">
                                <EllipsisHover className="dbi-title" text={itemEntityName} />
                                <div className="dbi-publisher-container">
                                  <img
                                    className="dbi-rank-card-info-desc-img"
                                    src={getCountryFlag(item?.publisher_country_abbre)}
                                    alt=""
                                  />
                                  <span className="dbi-publisher">{item?.publisher}</span>
                                </div>
                                {showGenres && (
                                  <div className="dbi-product-tags-container">
                                    {!!itemSuperGenre && (
                                      <span className="dbi-product-tags-text">{itemSuperGenre}</span>
                                    )}
                                    {!!itemMajorCategory && (
                                      <span className="dbi-product-tags-text">{itemMajorCategory}</span>
                                    )}
                                  </div>
                                )}
                              </div>
                              <Bubble content="点击前往游戏情报详情页">
                                <div
                                  className="dbi-arrow-icon"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    onGoToGameDetails?.(item);
                                  }}
                                >
                                  <a>
                                    <img src={IMG_ICON_GO} alt="icon" />
                                  </a>
                                </div>
                              </Bubble>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="dbi-item-content">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: markdownConverter.current.convertMarkdownToHTMLWithStyle(
                              getSanitizeHTMLString(item?.abstract) || '',
                              {
                                h3: '',
                                ul: '',
                                li: '',
                              },
                            ),
                          }}
                        ></div>
                        {renderLinker(item)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductChangedCard;
